import { ActionContext } from 'vuex';
import { AuthState, RootState, api } from '@/store';

export default ({ commit, state: { token } }: ActionContext<AuthState, RootState>) =>
  api.post({ url: '/signOut', token }).then(() => {
    commit('setToken', '');
    commit('cabinet/setUser', null, { root: true });
    commit('cabinet/setCompany', null, { root: true });
  });
